import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import Cascader from "./components/Cascader";
import CascaderSettings from "./components/CascaderSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/cascader_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export const defaultTreeOpts = [
  {
    value: 'jiangsu',
    label: 'Jiangsu',
    children: [
      {
        value: 'nanjing',
        label: 'Nanjing',
        children: [
          {
            value: 'zhonghuamen',
            label: 'Zhong Hua Men',
          },
        ],
      },
    ],
  },
];

export default () => {
  const messages = getLocale();
  return {
    name: 'cascader', // 插件名，不能包含空格,空格用-代替
    group: ElementGroup.SELECT, // 插件所在组，默认为ElementGroup.CUSTOM
    target: defaultTarget, // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages['PAGEBUIDER_ELEMENT_FORM_CASCADER'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: {
      formItemSettings: {
        options: defaultTreeOpts,
        allowClear: true,
        showSearch: false,
        optionFilterProp: 'label',
        autoInitialize: false,
        remote: {
          url: 'https://mock.iwhalecloud.com/mock/2880/cascaderOptions',
          method: 'GET',
          params: {}
        },
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_CASCADER'],
      },
      settings: {
        width: {
          value: '100%',
        },
      },
    },
    pluginComponent: Cascader, // 插件渲染组件
    pluginSettingComponent: CascaderSettings, // 插件设置项组件
  }
}
